import { NavLink, Outlet, useLocation } from 'react-router-dom'
import ManagementEventsSVG from 'components/svg/ManagementEventsSVG'
import { CONVERSION_REPORT_ROUTES as ROUTES } from 'constants/index'
import React, { useLayoutEffect } from 'react'

import { BarChart } from '@mui/icons-material'
import { List, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material'
import mixpanel from 'mixpanel-browser'

const routesMap = [
  {
    path: ROUTES.REPORT,
    icon: <BarChart />,
    title: 'Conversões',
    dataId: 'data-testid-conversion',
  },
  {
    path: ROUTES.MANAGEMENT_EVENTS,
    icon: <ManagementEventsSVG />,
    title: 'Gerenciar eventos',
  },
]

function ConversionReport() {
  const location = useLocation()
  const pathnameWithoutSlash = location.pathname.split('/')
  const routePath = pathnameWithoutSlash[pathnameWithoutSlash.length - 1]
  const locationPath = routePath === ROUTES.REPORT ? 'Relatório de conversões' : 'Gerenciar eventos'

  useLayoutEffect(() => {
    mixpanel.track_pageview({ page: 'Relatório de conversão' }, { event_name: 'Acesso - Relatório de Conversão' })
  }, [])

  return (
    <Stack direction="row" width="100%" height="100dvh">
      <Stack component="nav" mt="1rem" sx={{ width: '15%', padding: '0 0.5rem' }}>
        <List dense>
          {routesMap.map((route) => (
            <ListItemButton key={route.path} component={NavLink} to={route.path} selected={routePath === route.path}>
              <ListItemIcon sx={{ color: routePath === route.path ? '#00AEEF' : null }}>{route.icon}</ListItemIcon>
              <ListItemText data-testid={route.dataId}>{route.title}</ListItemText>
            </ListItemButton>
          ))}
        </List>
      </Stack>
      <Stack direction="column" mt="1rem" sx={{ width: '85%' }}>
        <Stack direction="row" padding="0.5rem">
          <Typography sx={{ color: 'text.secondary' }}>{'Relatórios / Geral / '}</Typography>
          <Typography sx={{ color: 'text.secondary', ml: '0.3rem', fontWeight: 'bold' }}>{locationPath}</Typography>
        </Stack>
        <Stack mt="1rem" p="0.5rem" sx={{ height: '100%', overflowY: 'auto' }}>
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}
export default ConversionReport
